/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation040.less';

interface IAnimation040Item {
  text: string;
  title: string;
  color: string;
}

interface IAnimation040Props {
  items: IAnimation040Item[];
  tip: string;
  className?: string;
  onCompleted?: () => void;
}

const Animation040: React.FunctionComponent<IAnimation040Props> = ({
  items,
  tip,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  return (
    <div ref={crrRef} className={`animation040 component ${className || ''}`}>
      <div className="animation040-content">
        {items.map((itm: IAnimation040Item, idx: number) => (
          <>
            <div
              key={idx}
              className={`animation040-item r${idx + 1} animation ${
                play >= idx + 1 ? 'fade-in' : ''
              }`}
              onClick={() => startPlay()}
            >
              <img
                className={`click-point ${play > 1 ? 'hide' : ''}`}
                src={ImgPoint}
                alt=""
              />
              <div
                className="animation040-rectangle-div"
                style={{ backgroundColor: itm.color }}
              >
                <div
                  className="animation040-title"
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                />
                <div
                  className="animation040-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
                {idx % 5 !== 4 && (
                  <div className="animation040-triangle-div">
                    <div
                      className="animation040-triangle-inner-div"
                      style={{ borderLeft: `18px solid ${itm.color}` }}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        ))}
      </div>
      {tip && (
        <div className="animation040-tip">
          <div className="tip" dangerouslySetInnerHTML={{ __html: tip }} />
        </div>
      )}
    </div>
  );
};

export default Animation040;
